import React, { Component } from 'react'
// import { Link, withRouter } from 'react-router-dom'
import { NavLink, withRouter } from 'react-router-dom';

import AuthenticationService from '../services/AuthenticationService';
import Translate from 'react-translate-component';
import { ICON_COLOR } from '../icon';
import {
    IoIosLogOut, IoIosSettings,
    IoMdPerson, IoIosPeople,
    IoMdReorder
} from 'react-icons/io';
import { FaStoreAlt, FaDatabase, FaFileAlt, FaInfoCircle } from 'react-icons/fa';
import { MdDashboard, MdDetails } from 'react-icons/md';
import TalkService from '../services/TalkService';
import SockJsClient from 'react-stomp';
import { SERVER_URL } from '../constants'

class MenuComponent2 extends Component {
    constructor() {
        super();
        this.state = {
            incidentCount: 0,
            newTalkCount: 0
        }

        console.log(SERVER_URL + '/websocket-notify/');
    }
    countNewTalks() {
        try {
            TalkService.countByStatus(1).then((data) => {
                this.setState({ newTalkCount: data });
            });
        } catch (e) {
            this.setState({ newTalkCount: 0 });
        }
    }
    componentDidMount() {
        this.countNewTalks();
    }

    renderNewTalks() {
        if (this.state.newTalkCount === undefined || this.state.newTalkCount === null || isNaN(this.state.newTalkCount)) {
            return '';
        }

        if (AuthenticationService.isAdmin() || AuthenticationService.isService() || AuthenticationService.isDesigner()) {
            return (<div className="red-text">{this.state.newTalkCount} mới</div>)
        }
        return ''
    }

    renderIncidents() {
        if (AuthenticationService.isAdmin() || AuthenticationService.isService() || AuthenticationService.isSupervisor() || AuthenticationService.isShipping()) {
            return (<div className="red-text">{this.state.incidentCount} lỗi mới</div>)
        }
        return ''
    }

    render() {
        if (this.props.isChild === true) {
            return (<></>);
        }

        // let pathname = window.location.pathname;

        const isUserLoggedIn = AuthenticationService.isUserLoggedIn();
        const isAdmin = AuthenticationService.isAdmin();
        const isService = AuthenticationService.isService();
        const isServiceOrShipping = AuthenticationService.isService() || AuthenticationService.isShipping();
        const isAdminOrService = AuthenticationService.isAdmin() || AuthenticationService.isService();
        const isShipping = AuthenticationService.isShipping();
        const isKhac = AuthenticationService.isKhac();
        const isKim = AuthenticationService.isKim();
        const isXi = AuthenticationService.isXi();
        const isBong = AuthenticationService.isBong();
        const isSupervisor = AuthenticationService.isSupervisor()
        const newTalkInfo = this.renderNewTalks();
        const isDesignerOrWorker = AuthenticationService.isDesigner() ||
            AuthenticationService.isKhac() ||
            AuthenticationService.isShipping();// ||
        //AuthenticationService.isWorker();
        const isWorker = AuthenticationService.isWorker();
        const isDelivery = AuthenticationService.isDelivery();
        const isKcs = AuthenticationService.isKcs();
        const isQuality = AuthenticationService.isQuality();
        const isDesignerOrKhac = AuthenticationService.isDesigner() || AuthenticationService.isKhac();
        const isAdminOrServiceOrDesigner = AuthenticationService.isAdmin() || AuthenticationService.isService() || AuthenticationService.isDesigner();
        const isAdminOrServiceOrDesignerShipping = isAdminOrServiceOrDesigner || AuthenticationService.isShipping() || AuthenticationService.isKhac() || AuthenticationService.isSupervisor() || AuthenticationService.isKim() || AuthenticationService.isXi() || AuthenticationService.isBong() || AuthenticationService.isWorker() || AuthenticationService.isQuality() || AuthenticationService.isDelivery() || AuthenticationService.isKcs();
        const isAdminOrShipping = AuthenticationService.isAdmin() || AuthenticationService.isShipping();
        //<bac url='https://justforlearning.xyz/websocket-notify> </bac>
        return (
            <div>
                {isUserLoggedIn &&
                    <div className="bs-example">
                        <div className="d-flex justify-content-between">
                            <div>
                                <label style={{ 'fontSize': '20px' }}><Translate content="app_name" /></label>&nbsp;&nbsp;v1.0.0
                            </div>
                            <div>
                                <b><span className="black-text justify-content-between"><IoMdPerson color={ICON_COLOR} /><Translate content="welcome" />{AuthenticationService.getUserName()}</span></b>
                            </div>
                        </div>
                    </div>
                }

                <nav className="navbar navbar-expand-md  navbar-light bg-info menu_bg">
                    {isAdminOrServiceOrDesignerShipping &&
                        <NavLink exact activeClassName="navbar__link--active" className="navbar__link" to="/"><MdDashboard color={ICON_COLOR} />&nbsp;<Translate content="dashboard" />{this.renderIncidents()}</NavLink>
                    }
                    {isAdminOrService &&
                        <NavLink activeClassName="navbar__link--active" className="navbar__link" to="/orders?caller=0"><IoMdReorder color={ICON_COLOR} />&nbsp;<Translate content="orders" /></NavLink>
                    }
                    {isKim &&
                        <NavLink activeClassName="navbar__link--active" className="navbar__link" to="/kimScan?caller=0"><IoMdReorder color={ICON_COLOR} />&nbsp;<Translate content="scanorder_kim" /></NavLink>
                    }
                    {isXi &&
                        <NavLink activeClassName="navbar__link--active" className="navbar__link" to="/materials"><IoIosSettings color={ICON_COLOR} />&nbsp;<Translate content="materials" /></NavLink>
                    }
                    {isKcs &&
                        <NavLink activeClassName="navbar__link--active" className="navbar__link" to="/hoanthanh"><IoIosSettings color={ICON_COLOR} />&nbsp;<Translate content="orders" /></NavLink>
                    }
                    {isXi &&
                        <NavLink activeClassName="navbar__link--active" className="navbar__link" to="/XiScan?caller=0"><IoMdReorder color={ICON_COLOR} />&nbsp;<Translate content="scanorder_xi" /></NavLink>
                    }
                    {isBong &&
                        <NavLink activeClassName="navbar__link--active" className="navbar__link" to="/bongScan?caller=0"><IoMdReorder color={ICON_COLOR} />&nbsp;<Translate content="scanorder_bong" /></NavLink>
                    }
                    {isShipping &&
                        <NavLink activeClassName="navbar__link--active" className="navbar__link" to="/shipOrders?caller=0"><IoMdReorder color={ICON_COLOR} />&nbsp;<Translate content="orders" /></NavLink>
                    }
                    {isShipping &&
                        <NavLink activeClassName="navbar__link--active" className="navbar__link" to="/ship?caller=0"><IoMdReorder color={ICON_COLOR} />&nbsp;<Translate content="ship_wo" /></NavLink>
                    }
                    {isShipping &&
                        <NavLink activeClassName="navbar__link--active" className="navbar__link" to="/shipWorkOrderScan?caller=0"><IoMdReorder color={ICON_COLOR} />&nbsp;<Translate content="scanorder" /></NavLink>
                    }
                    {isShipping &&
                        <NavLink activeClassName="navbar__link--active" className="navbar__link" to="/ShipBasketScan?caller=0"><IoMdReorder color={ICON_COLOR} />&nbsp;<Translate content="check_basket" /></NavLink>
                    }
                    {isShipping &&
                        <NavLink activeClassName="navbar__link--active" className="navbar__link" to="/errors?caller=0"><IoMdReorder color={ICON_COLOR} />&nbsp;<Translate content="errors" /></NavLink>
                    }
                    {isShipping &&
                        <NavLink activeClassName="navbar__link--active" className="navbar__link" to="/shipWorkOrderPrint?caller=0&print=1"><IoMdReorder color={ICON_COLOR} />&nbsp;<Translate content="printorder" /></NavLink>
                    }
                    {isAdminOrService &&
                        <NavLink activeClassName="navbar__link--active" className="navbar__link" to="/products?caller=0"><IoMdReorder color={ICON_COLOR} />&nbsp;<Translate content="production" /></NavLink>
                    }
                    {isKhac &&
                        <NavLink activeClassName="navbar__link--active" className="navbar__link" to="/khacs"><IoMdReorder color={ICON_COLOR} />&nbsp;<Translate content="khac_list" /></NavLink>
                    }
                    {isKhac &&
                        <NavLink activeClassName="navbar__link--active" className="navbar__link" to="/khacsearch"><IoMdReorder color={ICON_COLOR} />&nbsp;<Translate content="khac_search" /></NavLink>
                    }
                    {isSupervisor &&
                        <NavLink activeClassName="navbar__link--active" className="navbar__link" to="/super?caller=0"><IoMdReorder color={ICON_COLOR} />&nbsp;<Translate content="super_list" /></NavLink>
                    }
                    {isSupervisor &&
                        <NavLink activeClassName="navbar__link--active" className="navbar__link" to="/superext?caller=0"><IoMdReorder color={ICON_COLOR} />&nbsp;<Translate content="super_list_ext" /></NavLink>
                    }
                    {isKhac &&
                        <NavLink activeClassName="navbar__link--active" className="navbar__link" to="/prt?caller=0"><IoMdReorder color={ICON_COLOR} />&nbsp;<Translate content="super_list_prt" /></NavLink>
                    }
                    {isAdminOrService &&
                        <NavLink activeClassName="navbar__link--active" className="navbar__link" to="/changedWo"><IoMdReorder color={ICON_COLOR} />&nbsp;<Translate content="changed_wo" /></NavLink>
                    }
                    {/* {isService &&
                        <NavLink activeClassName="navbar__link--active" className="navbar__link" to="/serviceWorkOrderScan"><IoIosSettings color={ICON_COLOR} />&nbsp;<Translate content="service_wo_scan" /></NavLink>
                    } */}
                    {isAdminOrServiceOrDesigner &&
                        <NavLink activeClassName="navbar__link--active" className="navbar__link" to="/talks"><FaDatabase color={ICON_COLOR} />&nbsp;<Translate content="talks" />{newTalkInfo}</NavLink>
                    }
                    {isAdminOrService &&
                        <NavLink activeClassName="navbar__link--active" className="navbar__link" to="/importedFiles"><FaFileAlt color={ICON_COLOR} />&nbsp;<Translate content="imported_files" /></NavLink>
                    }
                    {isServiceOrShipping &&
                        <NavLink activeClassName="navbar__link--active" className="navbar__link" to="/shipPackages?caller=0"><IoMdReorder color={ICON_COLOR} />&nbsp;<Translate content="ship_packages" /></NavLink>
                    }
                    {isAdminOrShipping &&
                        <NavLink activeClassName="navbar__link--active" className="navbar__link" to="/khaihq?caller=0"><IoMdReorder color={ICON_COLOR} />&nbsp;<Translate content="ship_khaihq" /></NavLink>
                    }
                    {isShipping &&
                        <NavLink activeClassName="navbar__link--active" className="navbar__link" to="/shipDHL"><IoMdReorder color={ICON_COLOR} />&nbsp;<Translate content="ship_dhl" /></NavLink>
                    }
                    {isShipping &&
                        <NavLink activeClassName="navbar__link--active" className="navbar__link" to="/report"><IoMdReorder color={ICON_COLOR} />&nbsp;<Translate content="ship_report" /></NavLink>
                    }
                    {isAdminOrService &&
                        <NavLink activeClassName="navbar__link--active" className="navbar__link" to="/items"><FaDatabase color={ICON_COLOR} />&nbsp;<Translate content="items" /></NavLink>
                    }
                    {isAdminOrService &&
                        <NavLink activeClassName="navbar__link--active" className="navbar__link" to="/itemmappings"><FaDatabase color={ICON_COLOR} />&nbsp;<Translate content="itemmappings" /></NavLink>
                    }
                    {isAdmin &&
                        <NavLink activeClassName="navbar__link--active" className="navbar__link" to="/users"><IoIosPeople color={ICON_COLOR} />&nbsp;<Translate content="users" /></NavLink>
                    }
                    {isAdmin &&
                        <NavLink activeClassName="navbar__link--active" className="navbar__link" to="/shops"><FaStoreAlt color={ICON_COLOR} />&nbsp;<Translate content="shops" /></NavLink>
                    }
                    {isDesignerOrWorker && !isShipping && !isKhac &&
                        <NavLink activeClassName="navbar__link--active" className="navbar__link" to="/workOrders"><MdDetails color={ICON_COLOR} />&nbsp;<Translate content="work_orders" /></NavLink>
                    }
                    {isWorker &&
                        <NavLink activeClassName="navbar__link--active" className="navbar__link" to="/lendas"><MdDetails color={ICON_COLOR} />&nbsp;<Translate content="work_orders" /></NavLink>
                    }
                    {isWorker &&
                        <NavLink activeClassName="navbar__link--active" className="navbar__link" to="/LenScan"><MdDetails color={ICON_COLOR} />&nbsp;<Translate content="len_scan" /></NavLink>
                    }
                    {(isDesignerOrKhac) &&
                        <NavLink activeClassName="navbar__link--active" className="navbar__link" to="/ckfiles"><MdDetails color={ICON_COLOR} />&nbsp;<Translate content="work_orders_ckfiles" /></NavLink>
                    }
                    {isAdmin &&
                        <NavLink activeClassName="navbar__link--active" className="navbar__link" to="/settings"><IoIosSettings color={ICON_COLOR} />&nbsp;<Translate content="settings" /></NavLink>
                    }
                    {isService &&
                        <NavLink activeClassName="navbar__link--active" className="navbar__link" to="/settingsbyservice"><IoIosSettings color={ICON_COLOR} />&nbsp;<Translate content="settings" /></NavLink>
                    }
                    {isService &&
                        <NavLink activeClassName="navbar__link--active" className="navbar__link" to="/qr"><IoIosSettings color={ICON_COLOR} />&nbsp;<Translate content="quality_report" /></NavLink>
                    }
                    {isQuality &&
                        <NavLink activeClassName="navbar__link--active" className="navbar__link" to="/qr"><IoIosSettings color={ICON_COLOR} />&nbsp;<Translate content="quality_report" /></NavLink>
                    }
                    {isQuality &&
                        <NavLink activeClassName="navbar__link--active" className="navbar__link" to="/qualityproducts?caller=0"><IoMdReorder color={ICON_COLOR} />&nbsp;<Translate content="production" /></NavLink>
                    }
                    {(isAdmin || isSupervisor) &&
                        <NavLink activeClassName="navbar__link--active" className="navbar__link" to="/materialStocks"><IoIosSettings color={ICON_COLOR} />&nbsp;<Translate content="materialStocks" /></NavLink>
                    }
                    {isAdmin &&
                        <NavLink activeClassName="navbar__link--active" className="navbar__link" to="/logs"><FaInfoCircle color={ICON_COLOR} />&nbsp;<Translate content="logs" /></NavLink>
                    }
                    {/* {isAdmin && 
                        <NavLink activeClassName="navbar__link--active" className="navbar__link" to="/sql"><FaInfoCircle color={ICON_COLOR}/>&nbsp;<Translate content="sql_executor"/></NavLink>
                    } */}
                    {isAdmin &&
                        <NavLink activeClassName="navbar__link--active" className="navbar__link" to="/histories"><FaInfoCircle color={ICON_COLOR} />&nbsp;<Translate content="histories" /></NavLink>

                    }
                    {isAdmin &&
                        <NavLink activeClassName="navbar__link--active" className="navbar__link" to="/pls"><FaInfoCircle color={ICON_COLOR} />&nbsp;<Translate content="planning_simple" /></NavLink>

                    }
                    {isDelivery &&
                        <NavLink activeClassName="navbar__link--active" className="navbar__link" to="/dpk?caller=0"><IoMdReorder color={ICON_COLOR} />&nbsp;<Translate content="delivery_ship_packages" /></NavLink>
                    }
                    {isDelivery &&
                        <NavLink activeClassName="navbar__link--active" className="navbar__link" to="/dsus?caller=0"><IoMdReorder color={ICON_COLOR} />&nbsp;<Translate content="delivery_shipus_scan" /></NavLink>
                    }
                    {isQuality &&
                        <NavLink activeClassName="navbar__link--active" className="navbar__link" to="/er"><IoIosSettings color={ICON_COLOR} />&nbsp;<Translate content="error_report" /></NavLink>
                    }
                    {!isUserLoggedIn && <NavLink activeClassName="navbar__link--active" className="navbar__link" to="/login">
                        <Translate content="login" /></NavLink>
                    }
                    {isUserLoggedIn &&
                        <NavLink activeClassName="navbar__link--active" className="navbar__link" to="/logout" onClick={AuthenticationService.logout}><IoIosLogOut color="red" />&nbsp;<Translate content="logout" /></NavLink>
                    }

                </nav>

                {/* <SockJsClient url={SERVER_URL + '/websocket-notify/'}
                    topics={['/topic/user']}
                    onConnect={() => {
                        console.log("connected");
                    }}

                    onDisconnect={() => {
                        console.log("Disconnected");
                    }}

                    onMessage={(msg) => {
                        try {
                            this.setState({
                                incidentCount: this.state.incidentCount + 1
                            }, () => {
                                console.log(msg);
                                //alert('CO SU CO XAY RA VOI DON HANG "' + msg.note + '"');
                            });
                        } catch (e) {
                            console.log(e);
                        }
                    }}

                    ref={(client) => {
                        this.clientRef = client
                    }}
                /> */}
            </div>
        )
    }
}

export default withRouter(MenuComponent2)
